module.exports = __webpack_public_path__ + "static/cta-miaou-c5a8bac6a7e92be4bd47af69847ce786.svg";